import "react-app-polyfill/ie11"
import "core-js/stable"
import "regenerator-runtime/runtime"

import React from "react"
import ReactDOM from "react-dom"
import App from "./App"

import "@/styles"
import "@/helpers/addSso"

import { i18n } from "@/i18n"
import { getQueryParam } from "@/helpers/url"
import { getLanguage } from "@/services/api"

const renderApp = () => {
  const root = document.getElementById("root")
  root != null && ReactDOM.render(<App />, root)
}

let locale = getQueryParam("locale")

if (locale) {
  i18n.changeLanguage(locale)
  window.locale = locale
  renderApp()
} else {
  getLanguage()
    .then(({ data }) => {
      locale = data.currentUser.locale
      i18n.changeLanguage(locale)
      window.locale = locale
      renderApp()
      return null
    })
    .catch(err => {
      console && console.log && console.log(err)
      renderApp()
    })
}
